"use client";

import { BookCard } from "components/BooksSection";
import styles from "styles/components/books-page.module.css";

const BooksGrid = ({ books = [] }) => {
  if (!books.length) {
    return <div className={styles.emptyState}>Одоогоор ном олдсонгүй.</div>;
  }

  return (
    <section className={styles.gridSection}>
      <div className="container">
        <div className="row gy-4">
          {books.map((book) => (
            <div className="col-12 col-md-6 col-lg-4" key={book._id || book.id}>
              <BookCard book={book} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BooksGrid;
